import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2f31c277 = () => interopDefault(import('../../../pages/about-vfa.vue' /* webpackChunkName: "" */))
const _221161c1 = () => interopDefault(import('../../../pages/cookie-policy.vue' /* webpackChunkName: "" */))
const _103edbcc = () => interopDefault(import('../../../pages/dashboard.vue' /* webpackChunkName: "" */))
const _6baa3a83 = () => interopDefault(import('../../../pages/elections/index.vue' /* webpackChunkName: "" */))
const _5a8f65ba = () => interopDefault(import('../../../pages/envelope.vue' /* webpackChunkName: "" */))
const _706247e4 = () => interopDefault(import('../../../pages/equilateral-turnip.vue' /* webpackChunkName: "" */))
const _46568ef2 = () => interopDefault(import('../../../pages/faqs.vue' /* webpackChunkName: "" */))
const _61a07dca = () => interopDefault(import('../../../pages/faqs/index.vue' /* webpackChunkName: "" */))
const _0afbf2b0 = () => interopDefault(import('../../../pages/faqs/new-voters.vue' /* webpackChunkName: "" */))
const _5fe9dc82 = () => interopDefault(import('../../../pages/faqs/_slug.vue' /* webpackChunkName: "" */))
const _3c557da6 = () => interopDefault(import('../../../pages/gpp.vue' /* webpackChunkName: "" */))
const _4a610815 = () => interopDefault(import('../../../pages/request.vue' /* webpackChunkName: "" */))
const _b7259396 = () => interopDefault(import('../../../pages/request/sign-submit-nextsteps.vue' /* webpackChunkName: "" */))
const _3aaa869d = () => interopDefault(import('../../../pages/request/start-fpca.vue' /* webpackChunkName: "" */))
const _55f88669 = () => interopDefault(import('../../../pages/request/_stage.vue' /* webpackChunkName: "" */))
const _4536da2c = () => interopDefault(import('../../../pages/request/_stage/index.vue' /* webpackChunkName: "" */))
const _60613508 = () => interopDefault(import('../../../pages/scalene-hyssop.vue' /* webpackChunkName: "" */))
const _77bb676c = () => interopDefault(import('../../../pages/states.vue' /* webpackChunkName: "" */))
const _f380a622 = () => interopDefault(import('../../../pages/states/index.vue' /* webpackChunkName: "" */))
const _42ba8745 = () => interopDefault(import('../../../pages/states/_state.vue' /* webpackChunkName: "" */))
const _299fe6f2 = () => interopDefault(import('../../../pages/vfa-volunteers/index.vue' /* webpackChunkName: "" */))
const _bd35195e = () => interopDefault(import('../../../pages/voter/index.vue' /* webpackChunkName: "" */))
const _6a8c345a = () => interopDefault(import('../../../pages/voter-support/index.vue' /* webpackChunkName: "" */))
const _1ebd3688 = () => interopDefault(import('../../../pages/votertype.vue' /* webpackChunkName: "" */))
const _9ce2ec18 = () => interopDefault(import('../../../pages/elections/_state/index.vue' /* webpackChunkName: "" */))
const _18710793 = () => interopDefault(import('../../../pages/voter/_stage/index.vue' /* webpackChunkName: "" */))
const _0547af50 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "" */))
const _661d6cf4 = () => interopDefault(import('../../../pages/_page.vue' /* webpackChunkName: "" */))
const _3c996c77 = () => interopDefault(import('../../../pages/_page/index.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'is-active',
  linkExactActiveClass: 'is-active',
  scrollBehavior,

  routes: [{
    path: "/about-vfa",
    component: _2f31c277,
    name: "about-vfa-enUS"
  }, {
    path: "/esES/about-vfa",
    component: _2f31c277,
    name: "about-vfa-esES"
  }, {
    path: "/cookie-policy",
    component: _221161c1,
    name: "cookie-policy-enUS"
  }, {
    path: "/esES/cookie-policy",
    component: _221161c1,
    name: "cookie-policy-esES"
  }, {
    path: "/dashboard",
    component: _103edbcc,
    name: "dashboard-enUS"
  }, {
    path: "/esES/dashboard",
    component: _103edbcc,
    name: "dashboard-esES"
  }, {
    path: "/elections",
    component: _6baa3a83,
    name: "elections-enUS"
  }, {
    path: "/esES/elections",
    component: _6baa3a83,
    name: "elections-esES"
  }, {
    path: "/envelope",
    component: _5a8f65ba,
    name: "envelope-enUS"
  }, {
    path: "/esES/envelope",
    component: _5a8f65ba,
    name: "envelope-esES"
  }, {
    path: "/equilateral-turnip",
    component: _706247e4,
    name: "equilateral-turnip-enUS"
  }, {
    path: "/esES/equilateral-turnip",
    component: _706247e4,
    name: "equilateral-turnip-esES"
  }, {
    path: "/faqs",
    component: _46568ef2,
    children: [{
      path: "",
      component: _61a07dca,
      name: "faqs-enUS"
    }, {
      path: "new-voters",
      component: _0afbf2b0,
      name: "faqs-new-voters-enUS"
    }, {
      path: ":slug",
      component: _5fe9dc82,
      name: "faqs-slug-enUS"
    }]
  }, {
    path: "/esES/faqs",
    component: _46568ef2,
    children: [{
      path: "",
      component: _61a07dca,
      name: "faqs-esES"
    }, {
      path: "new-voters",
      component: _0afbf2b0,
      name: "faqs-new-voters-esES"
    }, {
      path: ":slug",
      component: _5fe9dc82,
      name: "faqs-slug-esES"
    }]
  }, {
    path: "/gpp",
    component: _3c557da6,
    name: "gpp-enUS"
  }, {
    path: "/esES/gpp",
    component: _3c557da6,
    name: "gpp-esES"
  }, {
    path: "/request",
    component: _4a610815,
    name: "request-enUS",
    children: [{
      path: "sign-submit-nextsteps",
      component: _b7259396,
      name: "request-sign-submit-nextsteps-enUS"
    }, {
      path: "start-fpca",
      component: _3aaa869d,
      name: "request-start-fpca-enUS"
    }, {
      path: ":stage?",
      component: _55f88669,
      children: [{
        path: "",
        component: _4536da2c,
        name: "request-stage-enUS"
      }]
    }]
  }, {
    path: "/esES/request",
    component: _4a610815,
    name: "request-esES",
    children: [{
      path: "sign-submit-nextsteps",
      component: _b7259396,
      name: "request-sign-submit-nextsteps-esES"
    }, {
      path: "start-fpca",
      component: _3aaa869d,
      name: "request-start-fpca-esES"
    }, {
      path: ":stage?",
      component: _55f88669,
      children: [{
        path: "",
        component: _4536da2c,
        name: "request-stage-esES"
      }]
    }]
  }, {
    path: "/scalene-hyssop",
    component: _60613508,
    name: "scalene-hyssop-enUS"
  }, {
    path: "/esES/scalene-hyssop",
    component: _60613508,
    name: "scalene-hyssop-esES"
  }, {
    path: "/states",
    component: _77bb676c,
    children: [{
      path: "",
      component: _f380a622,
      name: "states-enUS"
    }, {
      path: ":state",
      component: _42ba8745,
      name: "states-state-enUS"
    }]
  }, {
    path: "/esES/states",
    component: _77bb676c,
    children: [{
      path: "",
      component: _f380a622,
      name: "states-esES"
    }, {
      path: ":state",
      component: _42ba8745,
      name: "states-state-esES"
    }]
  }, {
    path: "/vfa-volunteers",
    component: _299fe6f2,
    name: "vfa-volunteers-enUS"
  }, {
    path: "/esES/vfa-volunteers",
    component: _299fe6f2,
    name: "vfa-volunteers-esES"
  }, {
    path: "/voter",
    component: _bd35195e,
    name: "voter-enUS"
  }, {
    path: "/esES/voter",
    component: _bd35195e,
    name: "voter-esES"
  }, {
    path: "/voter-support",
    component: _6a8c345a,
    name: "voter-support-enUS"
  }, {
    path: "/esES/voter-support",
    component: _6a8c345a,
    name: "voter-support-esES"
  }, {
    path: "/votertype",
    component: _1ebd3688,
    name: "votertype-enUS"
  }, {
    path: "/esES/votertype",
    component: _1ebd3688,
    name: "votertype-esES"
  }, {
    path: "/elections/:state",
    component: _9ce2ec18,
    name: "elections-state-enUS"
  }, {
    path: "/esES/elections/:state",
    component: _9ce2ec18,
    name: "elections-state-esES"
  }, {
    path: "/voter/:stage",
    component: _18710793,
    name: "voter-stage-enUS"
  }, {
    path: "/esES/voter/:stage",
    component: _18710793,
    name: "voter-stage-esES"
  }, {
    path: "/",
    component: _0547af50,
    name: "index-enUS"
  }, {
    path: "/esES",
    component: _0547af50,
    name: "index-esES"
  }, {
    path: "/:page",
    component: _661d6cf4,
    children: [{
      path: "",
      component: _3c996c77,
      name: "page-enUS"
    }]
  }, {
    path: "/esES/:page",
    component: _661d6cf4,
    children: [{
      path: "",
      component: _3c996c77,
      name: "page-esES"
    }]
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
